import { get } from 'lodash';
import axiosConfig from '../../../redux/ProductionData/axiosConfig';
import type { NdtIndicationRow } from '../components/dashboard/drilldown/drillDownTypes';

export interface FetchNdtLogsParams {
  project_id: number;
  weld_id?: string;
  pipe_id?: number;
  limit?: number;
  offset?: number;
}

function mapLog(log: Record<string, unknown>): NdtIndicationRow {
  const weldNumber = String(
    log.weld_id ?? log.weldId ?? log.weld_number ?? log.weldNumber ?? '',
  ).trim();
  const jobNumber = String(log.job_number ?? log.jobNumber ?? '').trim();
  return {
    id: log.id as string | number | undefined,
    date: String(log.date ?? ''),
    shift: String(log.shift ?? ''),
    ...(weldNumber ? { weldNumber } : {}),
    ...(jobNumber ? { jobNumber } : {}),
    oclockLocation: String(log.oclock_location ?? log.oclockLocation ?? ''),
    defectLocation: `${log.defect_location_start ?? log.defectLocationStart ?? ''}, ${log.defect_location_end ?? log.defectLocationEnd ?? ''}`.trim(),
    defectLength: log.defect_length || log.defectLength ? `${log.defect_length ?? log.defectLength} mm` : '',
    defectDepth: log.defect_depth || log.defectDepth ? `${log.defect_depth ?? log.defectDepth} mm` : '',
    defectHeight: log.defect_height || log.defectHeight ? `${log.defect_height ?? log.defectHeight} mm` : '',
    weldersN: String(log.welders_no ?? log.weldersNo ?? ''),
    welderRepNo: String(log.welder_repair_no ?? log.welderRepairNo ?? ''),
    location: String(log.location ?? ''),
    defectType: String(log.defect_type ?? log.defectType ?? ''),
    repair: String(log.repair ?? ''),
    comments: String(log.comments ?? ''),
    evaluation: String(log.evaluation ?? ''),
    passName: String(log.pass_name ?? log.passName ?? log.defect_name ?? log.defectName ?? ''),
    criticalWeld: String(log.critical_weld ?? log.criticalWeld ?? '') || undefined,
    wpsNumber: String(log.wps_number ?? log.wpsNumber ?? ''),
    acceptedWorkmanship: String(log.accepted_workmanship ?? log.acceptedWorkmanship ?? ''),
    rootCause: String(log.root_cause ?? log.rootCause ?? ''),
    time: String(log.time ?? ''),
  };
}

export async function fetchNdtIndicationLogsApi(
  params: FetchNdtLogsParams,
): Promise<NdtIndicationRow[]> {
  const { project_id, pipe_id, weld_id } = params;
  let url = `/ntdIndicationLog/getAllNtdIndicationLogs?project_id=${project_id}`;
  if (pipe_id != null && !Number.isNaN(Number(pipe_id))) {
    url += `&pipe_id=${Number(pipe_id)}`;
  }
  if (weld_id) {
    url += `&weld_id=${weld_id}`;
  }
  if (params.limit != null) {
    url += `&limit=${params.limit}`;
  }
  if (params.offset != null) {
    url += `&offset=${params.offset}`;
  }

  const res = await axiosConfig.get(url);
  if (res.status !== 200) return [];
  const logs = get(res, ['data', 'data', 'data'], []);
  return Array.isArray(logs) ? logs.map((log) => mapLog(log as Record<string, unknown>)) : [];
}

export function isNdtLogRejected(log: NdtIndicationRow): boolean {
  const evalText = String(log.evaluation ?? '').toLowerCase();
  return evalText.includes('reject') || evalText === 'fail' || evalText === 'failed';
}
